import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { CCTipoDeCuenta, CCTiposDeCuentasFormValues } from '../models/CCTiposDeCuentas';
import { store } from './store';

export default class CCTiposDeCuentasStore {

    CCTipoDeCuentaRegistry = new Map<any, CCTipoDeCuenta>();
    

    selectedCCTipoDeCuenta: CCTipoDeCuenta | undefined = undefined;

    // selectedCCTipoDeCuenta: CCTipoDeCuenta = {
    //     codigoTipoCuenta: 0,
    //     descripcion: "",
    //     creditoDebito: ""
    // };
    editMode = false;
    loading = false;
    loadingInitial = false;
 

    constructor() {
        makeAutoObservable(this)
    }

    get CCTipoDeCuentaByCodigo() {
        return Array.from(this.CCTipoDeCuentaRegistry.values());
    }

    get groupedCCTiposDeCuentas() {
        return this.CCTipoDeCuentaRegistry
    }

    loadCCTiposDeCuentas = async () => {
        this.loadingInitial = true;
        try {
            const CCTiposDeCuentas: CCTipoDeCuenta[] = await agent.CCTiposDeCuentas.list();
            CCTiposDeCuentas.forEach(element => {
                this.setCCTipoDeCuenta(element);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }
    
    loadCCTipoDeCuenta = async (codigoTipoCuenta: string) => {
        let CCTipoDeCuenta = this.getCCTipoDeCuenta(codigoTipoCuenta);
        if (CCTipoDeCuenta) {
            this.selectedCCTipoDeCuenta = CCTipoDeCuenta;
            return CCTipoDeCuenta;
        } else {
            this.loadingInitial = true;
            try {
                CCTipoDeCuenta =  await agent.CCTiposDeCuentas.details(codigoTipoCuenta);
                this.setCCTipoDeCuenta(CCTipoDeCuenta);
                runInAction(() => {
                    this.selectedCCTipoDeCuenta = CCTipoDeCuenta || this.selectedCCTipoDeCuenta;
                })
                this.setLoadingInitial(false);
                return CCTipoDeCuenta;
            } catch (error) {
                this.setLoadingInitial(false);
                return CCTipoDeCuenta;
            }
        }
    }

    dataShow = (data: CCTipoDeCuenta) =>{
        return data
    }

    private setCCTipoDeCuenta = (data: CCTipoDeCuenta) => {
        this.CCTipoDeCuentaRegistry.set(data.codigoTipoCuenta, data);
    }

    private getCCTipoDeCuenta = (codigoTipoCuenta: any) => {
        return this.CCTipoDeCuentaRegistry.get(codigoTipoCuenta);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    

    createCCTipoDeCuenta = async (CCTipoDeCuenta: CCTiposDeCuentasFormValues) => {
        try {
            await agent.CCTiposDeCuentas.create(CCTipoDeCuenta);
            runInAction(() => {
                this.selectedCCTipoDeCuenta = CCTipoDeCuenta;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    updateCCTipoDeCuenta = async (CCTipoDeCuenta: CCTiposDeCuentasFormValues) => {
        try {
            await agent.CCTiposDeCuentas.update(CCTipoDeCuenta);
            runInAction(() => {
                if (CCTipoDeCuenta.codigoTipoCuenta) {
                    let updateCCTipoDeCuenta = {...this.getCCTipoDeCuenta(CCTipoDeCuenta.codigoTipoCuenta), ...CCTipoDeCuenta}
                    this.CCTipoDeCuentaRegistry.set(CCTipoDeCuenta.codigoTipoCuenta, updateCCTipoDeCuenta as CCTipoDeCuenta);
                    this.selectedCCTipoDeCuenta = updateCCTipoDeCuenta as CCTipoDeCuenta
                    this.loading = false;
                }
                   
            } )
        } catch (error) {
        }
    }

    deleteCCTipoDeCuenta = async (codigoTipoCuenta: string) => {
        this.loading = true;
        try {
            await agent.CCTiposDeCuentas.delete(codigoTipoCuenta);
            runInAction(() => {
                this.CCTipoDeCuentaRegistry.delete(codigoTipoCuenta);
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }


}